import { inject, Injectable } from "@angular/core";

import { NotificationService } from "./notification.service";

@Injectable({ providedIn: 'root' })
export class ClipboardService {

	notify = inject(NotificationService)

	writeText(text: string) {
		const output = text.replace(/<br>/g, "\n").trim();

		if (navigator.clipboard) {
			navigator.clipboard.writeText(output).then(() => this.notifySuccess())
			return;
		}

		// old browsers
		const selBox = document.createElement('textarea');
		selBox.style.position = 'fixed';
		selBox.style.left = '0';
		selBox.style.top = '0';
		selBox.style.opacity = '0';
		selBox.value = output;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
		this.notifySuccess()
	}

	notifySuccess() {
		this.notify.success({ message: 'Toasts.TextCopied' })
	}
}